/* eslint-disable no-shadow */
import { string, shape } from 'prop-types';
import { removeModal } from 'Redux/modules/modal/actions';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'semantic-ui-react';

import PrescriptionForm from '../PrescriptionForm/PrescriptionForm';

import Pharmacy from './Pharmacy';
import styles from './PrescriptionModal.less';

const PrescriptionModal = props => {
  const dispatch = useDispatch();

  const {
    data: { conversation, pendingPrescription, pharmacies },
    id,
  } = props;
  const {
    status: { creating },
    error,
  } = useSelector(state => state.webChat.prescription);

  const [selectedPharmacy, setSelectedPharmacy] = useState(pendingPrescription?.pharmacy ?? null);
  const [step, setStep] = useState(1);

  let submitPrescriptionForm = null;

  const onClose = () => {
    dispatch(removeModal(id));
  };

  const handleSubmit = e => {
    if (step === 1) {
      setStep(step + 1);
      return;
    }

    if (submitPrescriptionForm) {
      submitPrescriptionForm(e);
    }
  };

  const handleCancel = () => {
    if (step === 1) {
      onClose();
    } else {
      setStep(step - 1);
    }
  };

  const bindSubmitForm = submitForm => {
    submitPrescriptionForm = submitForm;
  };

  const onSelectPharmacy = selectedPharmacy => {
    setSelectedPharmacy(selectedPharmacy);
  };

  const isPrescriptionCreating = creating === 0;

  useEffect(() => {
    if (pendingPrescription?.pharmacy) {
      setSelectedPharmacy(pendingPrescription?.pharmacy);
      setStep(2);
    }
  }, [pendingPrescription?.pharmacy]);

  useEffect(() => {
    if (!selectedPharmacy && !pendingPrescription && pharmacies.length > 0) {
      setSelectedPharmacy(pharmacies[0]);
    }
  }, [pharmacies, selectedPharmacy, pendingPrescription]);

  return (
    <Modal
      open
      size="large"
      className={styles.prescriptionModal}
      onClose={onClose}
      closeOnDimmerClick={false}
      closeIcon>
      {step === 1 && <Modal.Header>Issue Prescription</Modal.Header>}
      <Modal.Content>
        <div className={styles.content}>
          <div className={styles.prescriptionForm}>
            {step === 1 && (
              <Pharmacy
                selectedPharmacy={selectedPharmacy}
                pharmacy={pharmacies}
                onSelectPharmacy={onSelectPharmacy}
              />
            )}
            {step === 2 && (
              <PrescriptionForm
                close={onClose}
                bindSubmitForm={bindSubmitForm}
                conversation={conversation}
                selectedPharmacy={selectedPharmacy}
                pendingPrescription={pendingPrescription}
              />
            )}
          </div>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <div className={styles.btnActions}>
          <div>
            {creating === 2 && error?.message && (
              <div className={styles.error}>{error.message}</div>
            )}
          </div>
          <div>
            <Button
              onClick={handleCancel}
              content={step === 1 ? 'Cancel' : 'Back'}
              type="button"
              disabled={isPrescriptionCreating}
            />
            <Button
              content={step === 1 ? 'Next' : 'Submit'}
              type="button"
              primary
              onClick={handleSubmit}
              loading={isPrescriptionCreating}
              disabled={step === 1 ? !pharmacies?.length : isPrescriptionCreating}
            />
          </div>
        </div>
      </Modal.Actions>
    </Modal>
  );
};
export default PrescriptionModal;

PrescriptionModal.propTypes = {
  id: string.isRequired,
  data: shape({}).isRequired,
};
